module.exports = __webpack_public_path__ + "static/media/shop-logos.d75a4717.png";